module.exports = __webpack_public_path__ + "media/images/countrysquared/cn-779964a586bddc45ab630c3e39b2b6f1.svg";